import importerReducers from '../../../modules/shared/importer/importerReducers'
import actions from '../../../modules/teacher/importer/teacherImporterActions'

export default importerReducers(actions)
